import { useEffect, RefObject } from 'react';

const useIntersectionObserver = <T extends HTMLElement>(ref: RefObject<T>, onIntersect: IntersectionObserverCallback) => {

    useEffect(() => {
        const options: IntersectionObserverInit = {
            root: null,
            rootMargin: '8px',
            threshold: 0.25,
        };
        let loaderElement: T | null = null;
        const observer = new IntersectionObserver(onIntersect, options);
        if(ref && ref.current){
            observer.observe(ref.current);
            loaderElement = ref.current;
        }
        return () => {
            if(loaderElement){
                observer.unobserve(loaderElement);
            }
        };
    }, [ref, onIntersect]);

};

export default useIntersectionObserver;